import React, { useEffect, useState } from 'react';
import { json, Navigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { Session } from './utils/session';
import Sidebar from './Sidebar';
import './css/DataExecuter.css';

export default function DataExecuter() {
    const [query, setQuery] = useState('');
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);
    const [hideDesktop, setHideDesktop] = useState(false);
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const toggleSidebar = () => {
        if (window.innerWidth <= 991) {
            setShowMobileSidebar(s => !s);
        } else {
            setHideDesktop(s => !s);
        }
    };

    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth > 991) {
                setShowMobileSidebar(false);
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const handleExecute = async () => {
        setError(null);
        setResult(null);

        if (!query.trim()) {
            setError('Query is required');
            return;
        }

        setLoading(true);
        try {
            const token = Session.getToken();
            if (!token) throw new Error('Not authenticated');

            const res = await fetch(`${API_BASE_URL}/api/Query/execute`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ query }),
            });
            if (!res.ok) {
                let errMsg = `HTTP ${res.status}`;
                try {
                    const body = await res.clone().json();
                    if (body && typeof body === 'object') {
                        if (body.detail) errMsg = body.detail;
                        else if (body.message) errMsg = body.message;
                        else errMsg = JSON.stringify(body);
                    }
                } catch (_) {
                    try {
                        const txt = await res.clone().text();
                        if (txt) errMsg = txt;
                    } catch (__) { }
                }
                throw new Error(errMsg);
            }

            const data = await res.json();
            setResult(data);
        } catch (err) {
            setError(err.message || 'Request failed');
        } finally {
            setLoading(false);
        }
    };

    let data = [];
    if (Array.isArray(result)) data = result;
    else if (Array.isArray(result?.Data)) data = result.Data;
    else if (Array.isArray(result?.data)) data = result.data;

    const hasData = data.length > 0;
    const columns = hasData ? Object.keys(data[0]) : [];

    const isSuccessWithRows = (() => {
        if (!result) return false;
        const success = result.success ?? result.Success;
        const affected = result.affectedRows ?? result.AffectedRows;
        return success === true && Number(affected) > 0;
    })();

    const isSuperAdmin = Session.isSuperAdmin();
    if (!isSuperAdmin) {
        return <Navigate to="/" replace />;
    }

    return (
        <div>
            {showMobileSidebar && (
                <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
            )}
            <div
                id="sidebar"
                className={[
                    showMobileSidebar ? 'show-mobile' : '',
                    hideDesktop ? 'hide-desktop' : '',
                ].join(' ')}
            >
                <Sidebar />
            </div>
            <div id="content" className={`main-card ${hideDesktop ? 'full-width' : ''}`}>
                <div className="query-container">

                    <h2 className="title">Query Executor</h2>

                    <textarea
                        value={query}
                        onChange={e => setQuery(e.target.value)}
                        placeholder="Enter your query"
                        className="query-textarea"
                    />

                    <button
                        onClick={handleExecute}
                        disabled={loading}
                        className="execute-btn"
                    >
                        {loading ? 'Executing…' : 'Execute'}
                    </button>

                    {error && <div className="error">{error}</div>}

                    {hasData && (
                        <div className="table-wrapper">
                            <table className="result-table">
                                <thead>
                                    <tr>
                                        {columns.map(col => (
                                            <th key={col}>{col}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row, idx) => (
                                        <tr key={idx}>
                                            {columns.map(col => (
                                                <td key={col}>{row[col] ?? ''}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {result && !hasData && (
                        <div className={isSuccessWithRows ? 'success' : 'no-data'}>

                            {isSuccessWithRows ? (

                                <div>
                                    {(result?.queryType ?? result?.QueryType ?? '—')} successful
                                </div>

                            ) : (

                                <div>No data found.</div>

                            )}

                        </div>
                    )}




                </div>
            </div>
        </div>
    );
}
